import React, { useState, useEffect } from 'react';
import { Wifi, Coffee, Wind, Tv, Bath, Bed,Mail, MapPin, Phone, Users, Square, Eye, Star, Mountain, Droplets, Sun, Globe, ChevronRight, Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const NotreHotel = () => {
  const navigate = useNavigate(); // ✅ define it here
  const [language, setLanguage] = useState('fr');
  const [scrolled, setScrolled] = useState(false);

  const content = {
    fr: {
      title: 'Notre Hôtel',
      subtitle: 'Un Havre de Paix à Tafraoute',
      heroDesc: 'Découvrez Riad Lina, un havre de paix au cœur de la vallée d\'Ammelne près de Tafraout. Vivez une expérience unique entre détente, tradition et raffinement.',
      aboutTitle: 'Bienvenue au Riad Lina',
      aboutDesc: 'Niché au cœur de la magnifique vallée d\'Ammelne, le Riad Lina vous offre une expérience authentique marocaine alliant charme traditionnel et confort moderne. Chaque espace a été pensé pour votre bien-être et votre sérénité.',
      featuresTitle: 'Nos Atouts',
      features: [
        { icon: '🏔️', title: 'Vue Panoramique', desc: 'Vues spectaculaires sur les montagnes de l\'Anti-Atlas' },
        { icon: '🏊', title: 'Piscine', desc: 'espace détente' },
        { icon: '🎨', title: 'Décor Berbère Chic', desc: 'Architecture et décoration authentique' },
        { icon: '⭐', title: 'Service Premium', desc: 'Équipe attentive et professionnelle' }
      ],
      roomsTitle: 'Nos Chambres ',
      roomsSubtitle: 'Confort & Authenticité',
      rooms: [
        {
          name: 'Chambre simple',
          type: 'Suite Premium',
          surface: '45m²',
          price: '40€',
          guests: '2 personnes',
          img: 'img/image10.jpeg',
          desc: 'Notre suite la plus luxueuse avec terrasse privée et vue panoramique exceptionnelle sur la vallée',
          amenities: ['Terrasse privée', 'Vue panoramique', 'Baignoire spa', 'Salon séparé', 'Minibar', 'Climatisation'],
          services: ['Petit-déjeuner inclus', 'WiFi haute vitesse', 'Service en chambre', 'Produits de luxe']
        },
        {
          name: 'Chambre Double',
          type: 'Chambre Supérieure',
          surface: '32m²',
          price: '120€',
          guests: '2 personnes',
          img: 'img/image2.jpeg',
          desc: 'Chambre spacieuse avec décoration berbère raffinée et balcon donnant sur les montagnes',
          amenities: ['Balcon privé', 'Vue montagne', 'Douche italienne', 'Coin salon', 'Coffre-fort', 'Climatisation'],
          services: ['Petit-déjeuner inclus', 'WiFi gratuit', 'Linge de lit premium', 'Thé de bienvenue']
        },
        {
          name: 'Chambre Standard',
          type: 'Chambre Confort',
          surface: '25m²',
          price: '80€',
          guests: '2 personnes',
          img: 'img/image1.jpeg',
          desc: 'Chambre cosy au charme authentique marocain avec tout le confort moderne nécessaire',
          amenities: ['Fenêtre vue jardin', 'Salle de bain privée', 'Bureau', 'Placard', 'Ventilateur', 'Chauffage'],
          services: ['Petit-déjeuner inclus', 'WiFi gratuit', 'Serviettes fournies', 'Produits d\'accueil']
        }
      ],
      facilitiesTitle: 'Nos Espaces',
      facilities: [
        { name: 'Piscine Extérieure', desc: 'Piscine chauffée avec transats et parasols', img: 'img/image20.jpeg' },
        { name: 'Salon Marocain', desc: 'Espace traditionnel pour se détendre et socialiser', img: 'img/image0.jpeg' },
        { name: 'Terrasse Panoramique', desc: 'Espace détente avec vue à 360° sur la vallée', img: 'img/image22.jpeg' },

      ],
      contact: {
        title: 'Réservez Votre Séjour',
        address: 'TANDILT-AMMELNE-TAFROUT',
        phone: '+212 667 624183',
        whatssap: '+212 667 624183',
        email: 'CONTACT@RAIDLINA.MA'
      },
      viewMore: 'Voir Plus',
      bookNow: 'Réserver Maintenant',
      perNight: 'par nuit',
      amenitiesLabel: 'Équipements'
    },
    
  };
  const roomsData = {
  roomsTitle: 'Nos Chambres',
  roomsSubtitle: 'Confort & Authenticité',
  rooms: [
    {
      name: 'Chambre Simple',
      type: 'Suite Premium',
      img: 'img/image2.jpeg',
      desc: 'Chambre triple confortable avec vue sur les montagnes, idéale pour un séjour détente en famille ou entre amis.'
    },
    {
      name: 'Chambre Triple',
      type: 'Chambre Supérieure',
      img: 'img/image10.jpeg',
      desc: 'Chambre triple avec vue sur les montagnes, parfaite pour un séjour calme et ressourçant en pleine nature.'
    },
    {
      name: 'Chambre Double',
      type: 'Chambre Confort',
      img: 'img/image1.jpeg',
      desc: 'Chambre cosy pour deux personne, offrant une vue splendide sur les montagnes, parfaite pour un séjour reposant.'
    },
   
  ]
};

  const t = content[language];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div style={{ fontFamily: 'Georgia, serif', background: '#0a0a0a', color: '#fff' }}>
      <style>{`
        @import url('/img/bg2.jpg');
        
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Cormorant Garamond', serif; }
        
        // .fade-in { animation: fadeIn 1.2s ease-out; }
        // @keyframes fadeIn { from { opacity: 0; transform: translateY(40px); } to { opacity: 1; transform: translateY(0); } }
        
        // .slide-in { animation: slideIn 0.8s ease-out; }
        // @keyframes slideIn { from { opacity: 0; transform: translateX(-60px); } to { opacity: 1; transform: translateX(0); } }
        
        // .zoom-in { animation: zoomIn 0.8s ease-out; }
        // @keyframes zoomIn { from { opacity: 0; transform: scale(0.85); } to { opacity: 1; transform: scale(1); } }
        
        // .float { animation: float 6s ease-in-out infinite; }
        // @keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-20px); } }
        
        .luxury-card {
          background: linear-gradient(145deg, #1a1a1a, #0d0d0d);
          border: 1px solid rgba(212, 175, 55, 0.2);
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .luxury-card:hover {
          transform: translateY(-12px);
          border-color: rgba(212, 175, 55, 0.6);
          box-shadow: 0 25px 60px rgba(212, 175, 55, 0.25);
        }
        
        .img-overlay {
          position: relative;
          overflow: hidden;
        }
        .img-overlay::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.7) 100%);
          transition: opacity 0.3s;
        }
        .img-overlay:hover::after {
          opacity: 0.5;
        }
        
        .gold-line {
          background: linear-gradient(90deg, transparent, #d4af37, transparent);
          height: 2px;
        }
        
        .ornament {
          background: url("data:image/svg+xml,%3Csvg width='100' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 10 Q 25 0, 50 10 T 100 10' stroke='%23d4af37' stroke-width='2' fill='none'/%3E%3C/svg%3E") center no-repeat;
          width: 100px;
          height: 20px;
        }
        
        .text-gradient {
          background: linear-gradient(135deg, #d4af37 0%, #f9e79f 50%, #d4af37 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `}</style>

      {/* Hero Section */}
      <section style={{
        position: 'relative',
        height: '100vh',
        backgroundImage: 'url(img/bg6.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.7))'
        }} />
        
        <div style={{
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          textAlign: 'center', width: '90%', maxWidth: '1000px'
        }} className="fade-in">
          <div className="ornament" style={{ margin: '0 auto 30px' }} />
          <h1 style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: 'clamp(50px, 8vw, 100px)',
            fontWeight: 900,
            marginBottom: '30px',
            letterSpacing: '4px',
            textShadow: '3px 3px 30px rgba(0,0,0,0.8)'
          }} className="text-gradient float">
            {t.title}
          </h1>
          <p style={{
            fontSize: 'clamp(24px, 4vw, 36px)',
            marginBottom: '40px',
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic',
            color: '#d4af37',
            textShadow: '2px 2px 15px rgba(0,0,0,0.7)'
          }}>
            {t.subtitle}
          </p>
          <div className="gold-line" style={{ width: '200px', margin: '0 auto 50px' }} />
          <p style={{
            fontSize: 'clamp(16px, 2.5vw, 22px)',
            lineHeight: '1.8',
            maxWidth: '800px',
            margin: '0 auto',
            color: '#e0e0e0',
            textShadow: '1px 1px 10px rgba(0,0,0,0.8)'
          }}>
            {t.heroDesc}
          </p>
        </div>
      </section>

      {/* About Section */}
      <section style={{ padding: '120px 30px', background: '#0f0f0f' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }} className="slide-in">
          <h2 style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: 'clamp(36px, 5vw, 60px)',
            color: '#d4af37',
            marginBottom: '30px',
            fontWeight: 900
          }}>
            {t.aboutTitle}
          </h2>
          <div className="gold-line" style={{ width: '150px', margin: '0 auto 50px' }} />
          <p style={{
            fontSize: 'clamp(18px, 2.5vw, 24px)',
            lineHeight: '1.9',
            color: '#ccc',
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            {t.aboutDesc}
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ padding: '100px 30px', background: 'linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%)' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h2 style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: 'clamp(36px, 5vw, 60px)',
              fontWeight: 900,
              marginBottom: '20px'
            }} className="text-gradient">
              {t.featuresTitle}
            </h2>
            <div className="gold-line" style={{ width: '150px', margin: '0 auto' }} />
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '40px' }}>
            {t.features.map((feature, i) => (
              <div key={i} className="luxury-card zoom-in" style={{
                padding: '50px 30px',
                borderRadius: '20px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '60px', marginBottom: '25px' }}>{feature.icon}</div>
                <h3 style={{
                  fontFamily: 'Playfair Display, serif',
                  fontSize: '26px',
                  color: '#d4af37',
                  marginBottom: '15px',
                  fontWeight: 700
                }}>
                  {feature.title}
                </h3>
                <p style={{ fontSize: '18px', color: '#bbb', lineHeight: '1.6' }}>
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Rooms Section */}
      <section style={{ padding: '100px 10px', background: '#0f0f0f', position: 'relative', overflow: 'hidden' }}>

        {/* Decorative Background Elements */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '20%',
          transform: 'translate(-50%, -50%)',
          width: '500px',
          height: '800px',
          background: 'radial-gradient(circle, rgba(212, 175, 55, 0.05) 0%, transparent 70%)',
          pointerEvents: 'none'
        }} />

        <div style={{ maxWidth: '1400px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '80px' }} className="fade-in">
            <div className="ornament" style={{ 
              margin: '0 auto 20px',
              width: '60px',
              height: '2px',
              background: 'linear-gradient(90deg, transparent, #d4af37, transparent)'
            }} />
            <p style={{ 
              color: '#d4af37', 
              fontSize: '14px', 
              letterSpacing: '4px', 
              marginBottom: '15px', 
              fontWeight: 600,
              textTransform: 'uppercase'
            }}>
              {roomsData.roomsSubtitle}
            </p>
            <h2 style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: 'clamp(40px, 6vw, 70px)',
              fontWeight: 900,
              marginBottom: '20px',
              background: 'linear-gradient(135deg, #fff, #d4af37)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              {roomsData.roomsTitle}
            </h2>
            <div style={{ 
              width: '150px', 
              height: '3px',
              margin: '0 auto',
              background: 'linear-gradient(90deg, transparent, #d4af37, transparent)'
            }} />
          </div>

          {/* Gallery Grid */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', 
            gap: '30px',
            justifyItems: 'center'
          }}>
            {roomsData.rooms.map((room, i) => (
              <div key={i} className="gallery-item" style={{
                position: 'relative',
                height: '350px',
                width: '100%',
                maxWidth: '400px',
                borderRadius: '20px',
                overflow: 'hidden',
                cursor: 'pointer',
                boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
                transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                e.currentTarget.style.boxShadow = '0 20px 60px rgba(212, 175, 55, 0.3)';
                const overlay = e.currentTarget.querySelector('.overlay');
                if (overlay) overlay.style.opacity = '1';
                const img = e.currentTarget.querySelector('.room-img');
                if (img) img.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.5)';
                const overlay = e.currentTarget.querySelector('.overlay');
                if (overlay) overlay.style.opacity = '0';
                const img = e.currentTarget.querySelector('.room-img');
                if (img) img.style.transform = 'scale(1)';
              }}>
                {/* Background Image */}
                <div className="room-img" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundImage: `url(${room.img})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
                }} />

                {/* Gradient Overlay - Always visible */}
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '60%',
                  background: 'linear-gradient(to top, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.7) 50%, transparent 100%)',
                  pointerEvents: 'none'
                }} />

                {/* Content Overlay - Appears on hover */}
                <div className="overlay" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.15), rgba(0, 0, 0, 0.8))',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '40px',
                  opacity: 0,
                  transition: 'opacity 0.5s ease',
                  backdropFilter: 'blur(3px)'
                }}>
                  <div style={{
                    width: '80px',
                    height: '2px',
                    background: '#d4af37',
                    marginBottom: '25px',
                    transform: 'scaleX(0)',
                    animation: 'expandLine 0.6s ease forwards 0.2s'
                  }} />
                  <p style={{
                    fontSize: '18px',
                    color: '#d4af37',
                    letterSpacing: '3px',
                    marginBottom: '15px',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    opacity: 0,
                    animation: 'fadeInUp 0.5s ease forwards 0.3s'
                  }}>
                    {room.type}
                  </p>
                  <p style={{
                    fontSize: '17px',
                    color: '#ddd',
                    lineHeight: '1.7',
                    textAlign: 'center',
                    maxWidth: '320px',
                    opacity: 0,
                    animation: 'fadeInUp 0.5s ease forwards 0.4s'
                  }}>
                    {room.desc}
                  </p>
                </div>

                {/* Room Name - Always visible at bottom */}
                <div style={{
                  position: 'absolute',
                  bottom: '30px',
                  left: '30px',
                  right: '30px',
                  zIndex: 2
                }}>
                  <h3 style={{
                    fontFamily: 'Playfair Display, serif',
                    fontSize: '32px',
                    color: '#fff',
                    fontWeight: 700,
                    marginBottom: '8px',
                    textShadow: '2px 2px 10px rgba(0,0,0,0.8)'
                  }}>
                    {room.name}
                  </h3>
                  <div style={{
                    width: '50px',
                    height: '3px',
                    background: 'linear-gradient(90deg, #d4af37, transparent)',
                    marginTop: '10px'
                  }} />
                </div>

                {/* Corner Accent */}
                <div style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  width: '50px',
                  height: '50px',
                  border: '2px solid #d4af37',
                  borderBottom: 'none',
                  borderLeft: 'none',
                  opacity: 0.6
                }} />
              </div>
            ))}
          </div>
        </div>

        {/* CSS Animations */}
        <style>{`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes expandLine {
            from {
              transform: scaleX(0);
            }
            to {
              transform: scaleX(1);
            }
          }

          .gallery-item:hover .overlay {
            opacity: 1 !important;
          }

          @media (max-width: 768px) {
            .gallery-item {
              height: 380px !important;
            }
          }
        `}</style>
      </section>
      {/* Facilities Section */}
      <section style={{ padding: '120px 30px', background: 'linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 100%)' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }} className="fade-in">
            <h2 style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: 'clamp(40px, 6vw, 70px)',
              fontWeight: 900,
              marginBottom: '20px'
            }} className="text-gradient">
              {t.facilitiesTitle}
            </h2>
            <div className="gold-line" style={{ width: '150px', margin: '0 auto' }} />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '35px' }}>
            {t.facilities.map((facility, i) => (
              <div key={i} className="luxury-card" style={{
                borderRadius: '20px',
                overflow: 'hidden'
              }}>
                <div className="img-overlay" style={{
                  height: '250px',
                  backgroundImage: `url(${facility.img})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }} />
                <div style={{ padding: '30px' }}>
                  <h3 style={{
                    fontFamily: 'Playfair Display, serif',
                    fontSize: '24px',
                    color: '#d4af37',
                    marginBottom: '12px',
                    fontWeight: 700
                  }}>
                    {facility.name}
                  </h3>
                  <p style={{ fontSize: '16px', color: '#aaa', lineHeight: '1.7' }}>
                    {facility.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
       {/* Contact Section */}
          <section id="contact" style={{
              padding: '120px 30px',
              background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
              color: '#fff'
              }}>
              <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }} className="scale-in">
                <h2 style={{
                  fontFamily: 'Playfair Display, serif', fontSize: 'clamp(36px, 5vw, 56px)',
                  marginBottom: '30px', fontWeight: 700
                }}>
                Notre Hôtel

                </h2>
                <div style={{ width: '100px', height: '3px', background: '#d4af37', margin: '0 auto 60px' }} />
                
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '40px', marginBottom: '50px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <MapPin size={40} color="#d4af37" />
                    <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#d4af37' }}>Adresse</h3>
                    <p style={{ fontSize: '16px' }}>{t.contact.address}</p>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <Phone size={40} color="#d4af37" />
                    <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#d4af37' }}>Téléphone</h3>
                  <p style={{ fontSize: '16px' }}>{t.contact.phone}</p>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                    <Mail size={40} color="#d4af37" />
                    <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#d4af37' }}>Email</h3>
                    <p style={{ fontSize: '16px' }}>{t.contact.email}</p>
                  </div>
                </div>
      
                <button style={{
                  background: 'linear-gradient(135deg, #d4af37, #f9e79f)',
                  color: '#000', padding: '18px 50px', fontSize: '18px',
                  border: 'none', borderRadius: '50px', cursor: 'pointer',
                  fontWeight: 700, letterSpacing: '2px', transition: 'all 0.4s',
                  
                   }}
                   onClick={() => navigate('/contact')}
                   >
                  Réserver Maintenant      
                  </button>
              </div>
          </section>
    </div>
  );
};
export default NotreHotel;
